<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :footer="null"
    :maskClosable="false"
  >
    <a-form :form="form" :class="status == 1 ? 'readyOnly':''">
      <a-form-item style="display:none">
        <a-input v-decorator="['orderTypeId']"/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
        <a-select  v-decorator="['installTypeCode',{ rules: [{ required: true, message: '请选择安装类别' }] }]" @change="handleSelect">
          <a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单类型">
        <a-input v-decorator="['typeName',{ rules: [{ required: true, message: '请输入订单类型' }] }]"/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="默认金额类型">
        <a-select v-decorator="['defaultPriceTypeCode',{ rules: [{ required: true, message: '请选择默认金额类型' }] }]">
          <a-select-option v-for="item in data1" :key="item.id" :value="item.id">{{item.priceName}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否企业可见">
        <a-select v-decorator="['isEnterpriseSee',{ rules: [{ required: true, message: '请选择是否企业可见' }] }]">
          <a-select-option value="0">是</a-select-option>
          <a-select-option value="1">否</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序号">
        <a-input-number :min="0" :precision="0" v-decorator="['num']" style="width: 100%"/>
      </a-form-item>
    </a-form>
    <a-row :class="status == 1 ? 'readyOnly':''">
      <a-col :span="10"></a-col>
      <a-col :span="12">
        <a-button @click="handleSubmit" type="primary" style="margin-right: 10px">保存</a-button>
        <a-button @click="showModal">取消</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
  import { saveChannel,fieldType,save,update,getBasicPriceList } from '@/api/basicdatas/OrderType'
  import pick from 'lodash.pick'
  import { getDictMap } from '../../../utils/dict'

  export default {
    name: 'BrandModal',
    props: {
    },
    components: {
    },
    data () {
      return {
        queryParam: {},
        visible: false,
        restaurantTypes: [],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        data:[],
        data1:[],
        fieldType,
        course:'',
        status:0
      }
    },
    beforeCreate () {
    },
    async created () {
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
    },
    mounted () {
    },
    methods: {
      showModal () {
        this.visible = !this.visible
      },
      add () {
        this.form.resetFields()
        this.course=0
        this.visible = true
      },
      edit (record,status) {
        this.course=1
        this.status = status
        this.mdl = Object.assign(record)
        console.log(record)
        this.visible = true
        this.$nextTick(() => {
          getBasicPriceList({installationType:record.installTypeCode}).then(res=>{
            // console.log(res)
            this.data1=res.rows
          })
          this.form.setFieldsValue(pick(this.mdl, 'num', 'isEnterpriseSee', 'orderTypeId', 'defaultPriceTypeCode', 'installTypeCode', 'typeName'))
        })
      },
      handleSelect(value){
        this.data1 = []
        this.form.setFieldsValue({'defaultPriceTypeCode':''})
        getBasicPriceList({installationType:value}).then(res=>{
          // console.log(res)
          this.data1=res.rows
        })
      },
      handleSubmit (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            // console.log('Received values of form: ', values)
            this.confirmLoading = true
            if (this.course == 0){
              save(values).then(res => {
                if (res.code === 0) {
                  if(res.data == '名称重复'){
                    this.$message.error(res.data)
                  }else{
                    this.$message.success(res.data)
                    this.$emit('ok',1)
                    this.visible = false
                  }
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            } else if (this.course==1){
              update(values).then(res => {
                // console.log(values)
                if (res.code === 0) {
                  if(res.data == '名称重复'){
                    this.$message.error(res.data)
                  }else{
                    this.$message.success(res.data)
                    this.$emit('ok',2)
                    this.visible = false
                  }
                } else {
                  this.$message.error(res.msg)
                }
              }).catch(() => {
                this.$message.error('系统错误，请稍后再试')
              }).finally(() => {
                this.confirmLoading = false
              })
            }
          }
        })
      },
    },
    watch: {
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }
</script>
<style scoped>
  .readyOnly{
    pointer-events: none;
  }
</style>
